import "./style.less";

import basketConditionsModalController from "./modal-controller";
import basketConditionFactory from "./factory";

const modul = angular
    .module("basketConditionsModal", [])

    .factory("basketConditionFactory", basketConditionFactory)
    .controller(
        "basketConditionsModalController",
        basketConditionsModalController
    );

export default modul.name;
